import { useLayoutEffect } from 'react';
import { useUser } from 'src/UserContext';

export default function UserContainer(): JSX.Element {
  const { init } = useUser();

  useLayoutEffect(() => {
    init();
  }, []);
  return <></>;
}
